module.exports = __webpack_public_path__ + "media/images/icon_bell-2f4740b3e5f27661147637856af56aa6.svg";